import {
    FETCH_DISCIPLINE_LIST_REQUEST,
    FETCH_DISCIPLINE_LIST_SUCCESS,
    FETCH_DISCIPLINE_LIST_FAILURE,
  } from "./FetchDisciplineListTypes";
  import api from "../../utils/Api";
  
  export const fetchDisciplineListRequest = () => {
    return {
      type: FETCH_DISCIPLINE_LIST_REQUEST,
    };
  };
  
  export const fetchDisciplineListSuccess = (disciplineList) => {
    return {
      type: FETCH_DISCIPLINE_LIST_SUCCESS,
      payload: disciplineList,
    };
  };
  
  export const fetchDisciplineListFailure = (error) => {
    return {
      type: FETCH_DISCIPLINE_LIST_FAILURE,
      payload: error,
    };
  };
  
  export const fetchDisciplineList = () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
      dispatch(fetchDisciplineListRequest);
      try {
        const response = await api.get(
          "practise/discipline/list/fetch",
          {
            headers: headers,
          }
        );
  
        const disciplineList = response.data.data;
        dispatch(fetchDisciplineListSuccess(disciplineList));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchDisciplineListFailure(errorMsg));
      }
    };
  };
  